import _Promise from 'babel-runtime/core-js/promise';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Number$isNaN from 'babel-runtime/core-js/number/is-nan';

import _ from 'lodash';
import Uploader from '@/components/Uploader/index.vue';
import { reduceFileAccept } from '@/common/file';
import { fetchAdvertiserList, fetchAdvertiserContractList, fetchAdvertiserInfo } from '@/api/advertiser/manage.ts';
import { createInvoice } from '@/api/finance/invoice';

var ATTACHMENT_ACCEPT_TYPES = ['pdf', 'jpg', 'jpeg', 'png', 'xls', 'xlsx', 'xlsm', 'eml'];

var defaultForm = function defaultForm() {
  return {
    adv_id: null,
    contract_id: null,
    customer_id: null,
    estimate_company_code: '',
    estimate_company_name: '',
    traffic_type: 'MWS_MONTHLY_SPEND',
    currency: 'USD',
    tax_rate: 0,
    recharge_amount: null,
    amount: null,
    receipt_status: 1,
    remark: '',
    attachments: []
  };
};

var normalizeTaxRate = function normalizeTaxRate(value) {
  var taxRate = Number(value || 0);
  if (_Number$isNaN(taxRate)) return 0;
  if (taxRate > 1) return Number(taxRate.toFixed(2));
  return Number((taxRate * 100).toFixed(2));
};

export default {
  name: 'InvoiceDialog',
  components: {
    Uploader: Uploader
  },
  created: function created() {
    var _this = this;

    this.handleAdvertiserSearch = _.debounce(function (keyword) {
      _this.getAdvertiserList({
        keyword: keyword,
        search_field: 'name'
      });
    }, 200);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.handleAdvertiserSearch && this.handleAdvertiserSearch.cancel) {
      this.handleAdvertiserSearch.cancel();
    }
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      formValue: defaultForm(),
      amountInputSource: 'recharge_amount',
      syncingAmountField: false,
      advertiserList: [],
      contractList: [],
      invoicesList: [],
      contractLoading: false,
      invoiceLoading: false,
      attachmentFileList: [],
      companyOptions: [],
      customerMatchWarning: '',
      matchedCustomerOptions: []
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },
    attachmentAccept: function attachmentAccept() {
      return reduceFileAccept(ATTACHMENT_ACCEPT_TYPES);
    },
    rules: function rules() {
      var validateAttachments = function validateAttachments(rule, value, callback) {
        if (Array.isArray(value) && value.length) {
          callback();
          return;
        }
        callback(new Error('请至少添加一个附件'));
      };
      var r = {
        adv_id: [{ required: true, trigger: 'change', message: '请选择广告主' }],
        contract_id: [{ required: true, trigger: 'change', message: '请选择合同' }],
        customer_id: [{ required: true, trigger: 'change', message: '请选择客户' }],
        estimate_company_code: [{ required: true, trigger: 'change', message: '请选择收款主体' }],
        traffic_type: [{ required: true, trigger: 'blur', message: '请输入流量类型' }],
        currency: [{ required: true, trigger: 'change', message: '请选择币种' }],
        recharge_amount: [{ required: true, trigger: 'blur', message: '请输入充值金额' }],
        amount: [{ required: true, trigger: 'blur', message: '请输入开票金额' }],
        attachments: [{
          required: true,
          validator: validateAttachments,
          trigger: 'change'
        }]
      };
      return r;
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this2 = this;

      if (val) {
        this.formValue = defaultForm();
        this.amountInputSource = 'recharge_amount';
        this.syncingAmountField = false;
        this.contractList = [];
        this.companyOptions = [];
        this.invoicesList = [];
        this.contractLoading = false;
        this.attachmentFileList = [];
        this.customerMatchWarning = '';
        this.matchedCustomerOptions = [];
        this.$nextTick(function () {
          _this2.$refs.form && _this2.$refs.form.clearValidate();
          _this2.$refs.attachmentUploader && _this2.$refs.attachmentUploader.clearFiles();
        });
      }
    },
    'formValue.estimate_company_code': function formValueEstimate_company_code() {
      this.syncEstimateCompanyName();
    },
    'formValue.tax_rate': function formValueTax_rate() {
      this.syncAmountFields();
    },
    invoicesList: function invoicesList() {
      var _this3 = this;

      if (!this.formValue.contract_id || this.invoiceLoading) return;
      var currentContract = this.contractList.find(function (item) {
        return item.contract_id === _this3.formValue.contract_id;
      });
      this.syncCustomerByContract(currentContract);
    }
  },
  methods: {
    handleAdvertiserSearch: function handleAdvertiserSearch() {},
    getAdvertiserList: function getAdvertiserList() {
      var _this4 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetchAdvertiserList(params);

              case 3:
                res = _context.sent;

                _this4.advertiserList = _.get(res, 'data.data.list') || [];
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[0, 7]]);
      }))();
    },
    normalizeContractList: function normalizeContractList() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var contractList = Array.isArray(list) ? list : [];
      return contractList.map(function (item) {
        var contractId = item.contract_id || item.id || item.contract_code;
        var displayCode = item.protocol_code || item.contract_code;
        var displayParts = [item.partner_name, item.our_company_name].filter(Boolean);
        return _extends({}, item, {
          contract_id: contractId,
          contract_code: item.contract_code,
          display_code: displayCode,
          tax_rate: normalizeTaxRate(item.tax_rate),
          display_name: displayParts.join(' - '),
          label: [].concat(_toConsumableArray(displayParts), [displayCode]).filter(Boolean).join(' - ')
        });
      }).filter(function (item) {
        return !_.isNil(item.contract_id) && item.contract_id !== '';
      });
    },
    normalizeCompanyOptions: function normalizeCompanyOptions(subjectInfo) {
      var rawList = [];
      if (Array.isArray(subjectInfo)) {
        rawList = subjectInfo;
      } else if (subjectInfo) {
        rawList = [subjectInfo];
      }
      return rawList.map(function (item) {
        var code = item.company_code || item.code || item.our_subject_code || item.subject_code || '';
        var name = item.company_name || item.name || item.our_subject_name || item.subject_name || '';
        var label = item.label || [name, code].filter(Boolean).join(' - ');
        return _extends({}, item, {
          code: code,
          name: name,
          label: label
        });
      }).filter(function (item) {
        return item.code;
      });
    },
    normalizeInvoiceList: function normalizeInvoiceList() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var invoiceList = Array.isArray(list) ? list : [];
      return invoiceList.map(function (item) {
        var name = item.name || '';
        var company = item.company || '';
        return _extends({}, item, {
          label: [name, company].filter(Boolean).join(' - ')
        });
      });
    },
    loadContractList: function loadContractList() {
      var _this5 = this;

      var advId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.formValue.adv_id;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, contractList;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (advId) {
                  _context2.next = 3;
                  break;
                }

                _this5.contractList = [];
                return _context2.abrupt('return');

              case 3:
                _context2.prev = 3;

                _this5.contractLoading = true;
                _context2.next = 7;
                return fetchAdvertiserContractList({
                  adv_id: Number(advId),
                  type: 'recharge'
                });

              case 7:
                res = _context2.sent;
                contractList = _.get(res, 'data.data.list') || _.get(res, 'data.data') || [];

                _this5.contractList = _this5.normalizeContractList(contractList);
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](3);

                _this5.contractList = [];
                console.error(_context2.t0);

              case 16:
                _context2.prev = 16;

                _this5.contractLoading = false;
                return _context2.finish(16);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[3, 12, 16, 19]]);
      }))();
    },
    syncEstimateCompanyName: function syncEstimateCompanyName() {
      var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.formValue.estimate_company_code;

      var company = this.companyOptions.find(function (c) {
        return c.code === code;
      });
      this.formValue.estimate_company_name = company ? company.name : '';
    },
    normalizeCompareText: function normalizeCompareText(value) {
      return String(value || '').trim();
    },
    getContractPartnerMainSubjectName: function getContractPartnerMainSubjectName(contract) {
      return _.get(contract, 'partnerMainSubjectName') || _.get(contract, 'partner_main_subject_name') || _.get(contract, 'partner_name') || '';
    },
    syncCustomerByContract: function syncCustomerByContract(contract) {
      var _this6 = this;

      var partnerMainSubjectName = this.normalizeCompareText(this.getContractPartnerMainSubjectName(contract));
      if (!partnerMainSubjectName) {
        this.customerMatchWarning = '';
        this.matchedCustomerOptions = [];
        this.formValue.customer_id = null;
        return;
      }
      var matchedCustomers = this.invoicesList.filter(function (item) {
        return _this6.normalizeCompareText(item.company) === partnerMainSubjectName;
      });
      this.matchedCustomerOptions = matchedCustomers;
      if (matchedCustomers.length === 1) {
        this.formValue.customer_id = matchedCustomers[0].id;
        this.customerMatchWarning = '';
        return;
      }
      if (matchedCustomers.length > 1) {
        this.formValue.customer_id = null;
        this.customerMatchWarning = '\u5339\u914D\u5230\u591A\u4E2A\u5BA2\u6237\u4E3B\u4F53\uFF08' + partnerMainSubjectName + '\uFF09\uFF0C\u8BF7\u9009\u62E9\u4E00\u4E2A\u5BA2\u6237';
        return;
      }
      this.formValue.customer_id = null;
      this.customerMatchWarning = '\u8BE5\u5E7F\u544A\u4E3B\u4E0B\u4E0D\u5B58\u5728\u5F53\u524D\u5BA2\u6237\u4E3B\u4F53\uFF08' + partnerMainSubjectName + '\uFF09\uFF0C\u8BF7\u5148\u5728\u5E7F\u544A\u4E3B\u4FE1\u606F\u4E2D\u6DFB\u52A0';
    },
    handleCompanyChange: function handleCompanyChange(code) {
      this.syncEstimateCompanyName(code);
    },
    handleAdvChange: function handleAdvChange() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _ref, _ref2, res, info, currentContract;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // 切换广告主时清空客户选择
                _this7.formValue.customer_id = null;
                _this7.formValue.contract_id = null;
                _this7.formValue.tax_rate = 0;
                _this7.formValue.estimate_company_code = '';
                _this7.formValue.estimate_company_name = '';
                _this7.customerMatchWarning = '';
                _this7.contractList = [];
                _this7.companyOptions = [];
                _this7.invoicesList = [];
                _this7.matchedCustomerOptions = [];

                if (_this7.formValue.adv_id) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt('return');

              case 12:
                _context3.prev = 12;

                _this7.invoiceLoading = true;
                _context3.next = 16;
                return _Promise.all([fetchAdvertiserInfo({ id: _this7.formValue.adv_id }), _this7.loadContractList(_this7.formValue.adv_id)]);

              case 16:
                _ref = _context3.sent;
                _ref2 = _slicedToArray(_ref, 1);
                res = _ref2[0];
                info = _.get(res, 'data.data.info') || {};

                _this7.invoicesList = _this7.normalizeInvoiceList(info.invoices);
                if (_this7.formValue.contract_id) {
                  currentContract = _this7.contractList.find(function (item) {
                    return item.contract_id === _this7.formValue.contract_id;
                  });

                  _this7.syncCustomerByContract(currentContract);
                }
                _context3.next = 27;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3['catch'](12);

                console.error(_context3.t0);

              case 27:
                _context3.prev = 27;

                _this7.invoiceLoading = false;
                return _context3.finish(27);

              case 30:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[12, 24, 27, 30]]);
      }))();
    },
    handleContractChange: function handleContractChange(contractId) {
      var _this8 = this;

      var currentContract = this.contractList.find(function (item) {
        return item.contract_id === contractId;
      });
      this.companyOptions = this.normalizeCompanyOptions(_.get(currentContract, 'our_subject_info'));
      this.formValue.tax_rate = normalizeTaxRate(_.get(currentContract, 'tax_rate'));
      this.syncCustomerByContract(currentContract);
      var matchedCompany = this.companyOptions.find(function (item) {
        return item.code === _this8.formValue.estimate_company_code;
      });
      this.formValue.estimate_company_code = matchedCompany && matchedCompany.code || (this.companyOptions.length === 1 ? this.companyOptions[0].code : '');
      this.syncEstimateCompanyName();
    },
    handleRechargeAmountChange: function handleRechargeAmountChange(value) {
      if (this.syncingAmountField) return;
      this.amountInputSource = 'recharge_amount';
      this.syncAmountFromRechargeAmount(value);
    },
    handleInvoiceAmountChange: function handleInvoiceAmountChange(value) {
      if (this.syncingAmountField) return;
      this.amountInputSource = 'amount';
      this.syncRechargeAmountFromInvoiceAmount(value);
    },
    normalizeAmountValue: function normalizeAmountValue(value) {
      if (_.isNil(value) || value === '') return null;
      var amount = Number(value);
      return _Number$isNaN(amount) ? null : amount;
    },
    syncAmountFields: function syncAmountFields() {
      if (this.amountInputSource === 'amount') {
        this.syncRechargeAmountFromInvoiceAmount(this.formValue.amount);
        return;
      }
      this.syncAmountFromRechargeAmount(this.formValue.recharge_amount);
    },
    syncAmountFromRechargeAmount: function syncAmountFromRechargeAmount() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.formValue.recharge_amount;

      var rechargeAmount = this.normalizeAmountValue(value);
      var taxRate = this.normalizeAmountValue(this.formValue.tax_rate) || 0;
      var taxRateFactor = taxRate / 100;

      if (_.isNil(rechargeAmount)) {
        this.syncingAmountField = true;
        this.formValue.amount = null;
        this.syncingAmountField = false;
        return;
      }

      this.syncingAmountField = true;
      this.formValue.amount = Number((rechargeAmount * (1 + taxRateFactor)).toFixed(2));
      this.syncingAmountField = false;
    },
    syncRechargeAmountFromInvoiceAmount: function syncRechargeAmountFromInvoiceAmount() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.formValue.amount;

      var amount = this.normalizeAmountValue(value);
      var taxRate = this.normalizeAmountValue(this.formValue.tax_rate) || 0;
      var taxRateFactor = taxRate / 100;
      var taxMultiplier = 1 + taxRateFactor;

      if (_.isNil(amount)) {
        this.syncingAmountField = true;
        this.formValue.recharge_amount = null;
        this.syncingAmountField = false;
        return;
      }

      if (taxMultiplier <= 0) {
        this.syncingAmountField = true;
        this.formValue.recharge_amount = null;
        this.syncingAmountField = false;
        return;
      }

      this.syncingAmountField = true;
      this.formValue.recharge_amount = Number((amount / taxMultiplier).toFixed(2));
      this.syncingAmountField = false;
    },
    formatTaxRateDisplay: function formatTaxRateDisplay(value) {
      var taxRate = Number(value);
      return _Number$isNaN(taxRate) ? 0 : taxRate;
    },
    getAttachmentExtension: function getAttachmentExtension(file) {
      var fileName = _.get(file, 'name', '');
      var extension = fileName.includes('.') ? fileName.split('.').pop() : '';
      return (extension || '').toLowerCase();
    },
    beforeAttachmentUpload: function beforeAttachmentUpload(file) {
      var extension = this.getAttachmentExtension(file);
      if (!ATTACHMENT_ACCEPT_TYPES.includes(extension)) {
        this.$message.warning('附件仅支持 PDF、JPG、JPEG、PNG、XLS、XLSX、XLSM、EML 格式');
        return false;
      }
      var isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$message.warning('上传文件大小不能超过 100MB');
        return false;
      }
      return true;
    },
    handleAttachmentChange: function handleAttachmentChange(file, fileList) {
      this.attachmentFileList = fileList;
      this.syncAttachmentsFromFileList(fileList);
      this.validateAttachmentField();
    },
    handleAttachmentUploadSuccess: function handleAttachmentUploadSuccess(response, file, fileList) {
      if (response.code !== 0) {
        this.$message.warning(response.msg || '附件上传失败，请重试');
        this.attachmentFileList = fileList.filter(function (item) {
          return item.uid !== file.uid;
        });
        this.syncAttachmentsFromFileList(this.attachmentFileList);
        this.validateAttachmentField();
        return;
      }
      file.name = response.data.origin_name;
      file.url = response.data.file_path;
      this.attachmentFileList = fileList;
      this.syncAttachmentsFromFileList(fileList);
      this.validateAttachmentField();
    },
    handleAttachmentRemove: function handleAttachmentRemove(file, fileList) {
      this.attachmentFileList = fileList;
      this.syncAttachmentsFromFileList(fileList);
      this.validateAttachmentField();
    },
    handleAttachmentPreview: function handleAttachmentPreview(file) {
      var fileUrl = _.get(file, 'response.data.file_path') || file.url || _.get(file, 'raw.url');
      fileUrl && window.open(fileUrl);
    },
    syncAttachmentsFromFileList: function syncAttachmentsFromFileList() {
      var fileList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.attachmentFileList;

      this.formValue.attachments = fileList.map(function (item) {
        return {
          file_name: _.get(item, 'response.data.origin_name') || item.name || '',
          file_url: _.get(item, 'response.data.file_path') || item.url || ''
        };
      }).filter(function (item) {
        return item.file_name && item.file_url;
      });
    },
    validateAttachmentField: function validateAttachmentField() {
      var _this9 = this;

      this.$nextTick(function () {
        _this9.$refs.form && _this9.$refs.form.validateField('attachments');
      });
    },
    closeDialog: function closeDialog() {
      this.$emit('update:visible', false);
    },
    submit: function submit() {
      var _this10 = this;

      this.$refs.form.validate(function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(valid) {
          var attachments, rechargeAmount, payload, amount, taxRate;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (valid) {
                    _context4.next = 2;
                    break;
                  }

                  return _context4.abrupt('return');

                case 2:
                  // 过滤掉空附件
                  attachments = _this10.formValue.attachments.filter(function (a) {
                    return a.file_name || a.file_url;
                  });
                  rechargeAmount = Number(_this10.formValue.recharge_amount || 0);
                  payload = _.omit(_this10.formValue, ['recharge_amount', 'contract_id']);
                  amount = Number(_this10.formValue.amount || 0);
                  taxRate = Number(_this10.formValue.tax_rate || 0);
                  _context4.prev = 7;

                  _this10.loading = true;
                  _context4.next = 11;
                  return createInvoice(_extends({}, payload, {
                    tax: Number((rechargeAmount * taxRate / 100).toFixed(2)),
                    actual_amount: amount,
                    amount: amount,
                    attachments: attachments
                  }));

                case 11:
                  _this10.$message.success('提交成功');
                  _this10.closeDialog();
                  _this10.$emit('save-success');
                  _context4.next = 19;
                  break;

                case 16:
                  _context4.prev = 16;
                  _context4.t0 = _context4['catch'](7);

                  console.error(_context4.t0);

                case 19:
                  _context4.prev = 19;

                  _this10.loading = false;
                  return _context4.finish(19);

                case 22:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this10, [[7, 16, 19, 22]]);
        }));

        return function (_x9) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }
};